// extracted by mini-css-extract-plugin
export default {"outer-wrapper":"styles_outer-wrapper__U7fA8","button":"styles_button__7ujXx","star":"styles_star__ghETS","product-image-container":"styles_product-image-container__2mgWw"};